// Maps a blob's type string to the Shell component that renders it, keeping the router
// (pages/Blob/index.js) and any other caller (e.g. components/blob/shortcuts) from having to
// know the five type strings themselves.
import GraphOrientdbShell from 'blob_types/blobhub/graph/orientdb/shell/index';
import ModelOnnxShell from 'blob_types/blobhub/model/onnx/shell/index';
import DatasetNlpShell from 'blob_types/blobhub/dataset/nlp/shell/index';
import ComputeWorkflowShell from 'blob_types/blobhub/compute/workflow/shell/index';
import ComputeSchedulerShell from 'blob_types/blobhub/compute/scheduler/shell/index';

export const SHELLS = {
  "blobhub.graph.orientdb": GraphOrientdbShell,
  "blobhub.model.onnx": ModelOnnxShell,
  "blobhub.dataset.nlp": DatasetNlpShell,
  "blobhub.compute.workflow": ComputeWorkflowShell,
  "blobhub.compute.scheduler": ComputeSchedulerShell,
};

export function resolveShell(type) {
  return SHELLS[type] || null;
}
